export const assetsList = [
    {
        description: 'assetsList.level1',
        label: 'assetsList.level1',
        type: 'assetsList',
        value: '1'
    },
    {
        description: 'assetsList.level2',
        label: 'assetsList.level2',
        type: 'assetsList',
        value: '2'
    },
    {
        description: 'assetsList.level3',
        label: 'assetsList.level3',
        type: 'assetsList',
        value: '3'
    },
    {
        description: 'assetsList.level4',
        label: 'assetsList.level4',
        type: 'assetsList',
        value: '4'
    },
    {
        description: 'assetsList.level5',
        label: 'assetsList.level5',
        type: 'assetsList',
        value: '5'
    },
    {
        description: 'assetsList.level6',
        label: 'assetsList.level6',
        type: 'assetsList',
        value: '6'
    }
];

export default assetsList;